if(typeof userHighlights == 'undefined') var userHighlights = {};

var showTitles, showAddress = true;
var showCompany = false;
let measureActive = false,
    mapResizing = false,
    showLandUse = false;

/* For routing tool */
let coordFrom, coordTo, startMarker, endMarker = null;

const distanceContainer = $('#distance');
const distanceInner = $('#distance .distance-container');
const resultDiv = $('#distance .result');
const measureFeatures = {
    'type': 'FeatureCollection',
    'features': []
};

// Zoom levels
const zoomLevels = {
    'addresses': 13,
    'markers': 8,
    'default': 11.5,
    'lucas': 11.5
}

const linestring = {
    'type': 'Feature',
    'geometry': {
        'type': 'LineString',
        'coordinates': []
    }
};

let companyLayers = [];

let searchString;

var map, autocomplete, foo,
    initAutocomplete = function () {
        let centrePoint, oGCentrePoint, marker;
        let regionAreas = $('.hidden-region');

        if ($('#map').length) {
            initMap();
            let options = {
                units: 'kilometers'
            }

            $('#map-style-menu').on('click', 'a', function () {
                let input = $(this).children('label').children('input');
                let inputs = $('.map-style');
                let layerID = input.attr('id');

                $.each(inputs, function () {
                    $(this).attr('checked', false);
                    if ($(this)[0] === input[0] && !$(this).closest('.layer-option').hasClass('hidden')) {
                        $(this).closest('.layer-option').toggleClass('hidden');
                    } else if ($(this)[0] !== input[0] && $(this).closest('.layer-option').hasClass('hidden')) {
                        $(this).closest('.layer-option').toggleClass('hidden');
                    }
                });

                input.attr('checked', true);

                if (layerID === 'default-layer') {
                    map.setPaintProperty('hd-aerial', 'raster-opacity', 0);
                    // map.setPaintProperty('property-titles', 'raster-opacity', 1);

                    if (map.getLayer('hd-aerial')) {
                        map.removeLayer('hd-aerial');
                    }
                } else {
                    if (!map.getLayer('hd-aerial')) {
                        map.addLayer({
                                'id': 'hd-aerial',
                                'type': 'raster',
                                'source': 'hd-aerial',
                                'paint': {
                                    'raster-opacity': 0
                                }
                            },
                            'road-street'
                        );

                        map.setPaintProperty('hd-aerial', 'raster-opacity', 1);
                    }
                }
            });

            $('#map-layer-menu .layer-checkbox').on('change', function () {
                const layerID = $(this).data('layer');

                if ($(this).is(':checked')) {
                    // Add only if not already in the array
                    if (!companyLayers.includes(layerID)) {
                        companyLayers.push(layerID);
                    }
                } else {
                    // Remove from array
                    companyLayers = companyLayers.filter(id => id !== layerID);
                }
                map.fire('moveend');
                map.triggerRepaint();
            });

            // Tool / control click delegation.
            // Previously bound to '#map-options div' only. The new design moves
            // measure-tool / route-tool into the left panel as cards, so we
            // delegate from the whole .rural-map container and use the
            // hasClass() checks below to dispatch. Clicks on form controls
            // inside the cards (inputs/buttons/etc.) are ignored so they don't
            // accidentally toggle the parent tool card.
            $('.rural-map').on('click', '.option', function (e) {
                if (e.target.closest('input, select, textarea, button, a')) return;
                if (map) {
                    if ($(this).hasClass('zoom-in')) {
                        map.easeTo({
                            'zoom': map.getZoom() + 1,
                            'duration': 500
                        })
                    } else if ($(this).hasClass('zoom-out')) {
                        map.easeTo({
                            'zoom': map.getZoom() - 1,
                            'duration': 500
                        })
                    } else if ($(this).hasClass('current-location')) {
                        if (marker) marker.remove();
                        navigator.geolocation.getCurrentPosition(function (position) {
                                map.flyTo({
                                    duration: 4000,
                                    center: [position.coords.longitude, position.coords.latitude],
                                    zoom: 18
                                });
                            },
                            function (error) {
                                if (error.code === error.PERMISSION_DENIED) {
                                    alert(
                                        `Location access is blocked. Please re-enable it in your browser:\n\n` +
                                        `Chrome: Click the padlock next to the URL → Site Settings → Location → Allow\n` +
                                        `Firefox: Preferences → Privacy & Security → Permissions → Location → Settings\n` +
                                        `Safari: Safari → Settings for This Website → Location: Allow\n\n` +
                                        `Please then reload the page to enable this change.`
                                    );
                                } else {
                                    alert('Unable to find your location.');
                                }
                            });
                    } else if ($(this).hasClass('reset-bearing')) {
                        map.resetNorth({duration: 2000});
                    } else if ($(this).hasClass('route-tool')) {
                        if($('.measure-tool').hasClass('active')) $('.measure-tool').trigger('click'); //FIXME: Better way to do this for future tools

                        $(this).toggleClass('active');
                        $('#routeTool').toggleClass('active');

                        coordFrom = coordTo = null;
                        if (startMarker) startMarker.remove();
                        if (endMarker) endMarker.remove();
                        $('#routeInfo').css('display', 'none');
                        $('#routeStart').val('');
                        $('#routeEnd').val('');
                        if (map.getLayer('orsLayer')) {
                            map.removeLayer('orsLayer');
                        }

                        $('.rm-panel--left').animate({
                            scrollTop: $(this).offset().top
                        }, 1000);
                    } else if ($(this).hasClass('measure-tool')) {
                        if($('.route-tool').hasClass('active')) $('.route-tool').trigger('click');

                        $(this).toggleClass('active');
                        measureActive = !measureActive;

                        if(!measureActive) {
                            measureFeatures.features = [];
                            map.getSource('geojson').setData(measureFeatures);

                            resultDiv.html('');
                            map.off('mousemove');

                            distanceContainer.css('display', 'none');
                            distanceInner.css('display', 'none');
                        } else {
                            distanceContainer.css('display', 'block');
                        }

                        $('.rm-panel--left').animate({
                            scrollTop: $(this).offset().top
                        }, 1000);
                    } else if ($(this).hasClass('land-use-overlay')) {
                        $(this).toggleClass('active');
                        showLandUse = !showLandUse;

                        let titleEl = $(this).find('.rm-tool__title');
                        if(showLandUse) {
                            titleEl.html(titleEl.html().replace('Enable', 'Disable'));
                            // Reload Map
                            map.fire('moveend');
                            map.triggerRepaint();

                            $('.rm-panel--left').animate({
                                scrollTop: $(this).offset().top
                            }, 1000);
                        } else {
                            titleEl.html(titleEl.html().replace('Disable', 'Enable'));

                            updatePropertyTypeFilterVisibility(null);
                            loadTitlesToMap(filteredTitles());
                        }
                    }
                }
            });

            var service = new google.maps.places.AutocompleteService();
            autocomplete = new google.maps.places.Autocomplete(
                $('#autocomplete-search').get(0),
                {
                    componentRestrictions: {'country': ['NZ']},
                    fields: ['place_id', 'geometry', 'name']
                });

            // This is the function that places the marker of the location you searched + flies to it
            autocomplete.addListener('place_changed', function () {
                let setCoords = onPlaceChanged();
                if (marker) marker.remove(); // Remove existing marker

                marker = new mapboxgl.Marker()
                    .setLngLat([setCoords['long'], setCoords['lat']])
                    .addTo(map);

                map.flyTo({
                    duration: 4000,
                    center: [setCoords['long'], setCoords['lat']],
                    zoom: 18
                });

                if(window.screen.width <= 680) {
                    const $wrapper = $('#left-panel-wrapper');
                    $wrapper.toggleClass('is-collapsed');
                    $('#left-panel-toggle').find('i')
                        .toggleClass('fa-chevron-left')
                        .toggleClass('fa-chevron-right');
                }
            });

            $('.autocomplete-clear').on('click', function (e) {
                e.preventDefault();
                // $(this).closest('.addressAutocomplete').val('');
                $('#autocomplete-search').val('');
                if (marker) marker.remove();
            });

            var newSpotTimer = null,
                moveSpotTimer = null,
                mapReady = false;

            // Set initial center point
            if (!oGCentrePoint)
                oGCentrePoint = map.getBounds().getCenter();

            map.on('moveend', function () {
                if(mapResizing) return
                const bounds = map.getBounds();
                const zoom = map.getZoom();

                window.clearTimeout(moveSpotTimer);
                moveSpotTimer = window.setTimeout(function () {
                    centrePoint = map.getBounds().getCenter(); // Get the current map position

                    // Calculate the distance the user has panned the map
                    let ogCentre = [oGCentrePoint['lng'], oGCentrePoint['lat']]
                    let currCentre = [centrePoint['lng'], centrePoint['lat']]
                    let d = turf.distance(ogCentre, currCentre, options);
                }, 500)

                if(map.getLayer('addresses-layer')) {
                    if(zoom > 15) {
                        map.setLayoutProperty('addresses-layer', 'text-field', ['get', 'full_address']);
                    } else {
                        map.setLayoutProperty('addresses-layer', 'text-field', ['get', 'full_address_number']);
                    }
                }

                // Get Property titles/address
                //if (zoom >= 11) { // Split out to zoom levels
                    // Get bounds
                    // const bounds = map.getBounds();

                    // Extend by a small buffer (e.g. 10% of the current bounds)
                    const lngBuffer = (bounds.getEast() - bounds.getWest()) * 0.1;
                    const latBuffer = (bounds.getNorth() - bounds.getSouth()) * 0.1;

                    const extendedBBox = [
                        bounds.getWest(), //- lngBuffer,
                        bounds.getSouth(), //- latBuffer,
                        bounds.getEast(), //+ lngBuffer,
                        bounds.getNorth() //+ latBuffer
                    ].join(',');

                    fetchFeatures(bounds, zoom);
               //} else {
                    hideFeatures(zoom);
                    applyOwnerFilter();
                //}

            });

            map.on('movestart', function () {
                window.clearTimeout(newSpotTimer)
                window.clearTimeout(moveSpotTimer)
            });

            map.on('load', function () {
                window.setTimeout(function () {
                    mapReady = true;
                    oGCentrePoint = map.getBounds().getCenter()
                }, 1000);
            });

            map.loadImage(
                '_resources/themes/ruralmaps/images/dotted-fill.png',
                (err, image) => {
                    if(err) console.log(err);
                    map.addImage('pattern', image);
                }
            );
        }

        if ($('#map2').length) {
            initMap2();
        }
    }

function getEventId(type) {
    return (new Date()).valueOf() + type + Math.round(Math.random() * 10000)
}

function onPlaceChanged() {
    var place = autocomplete.getPlace();

    if (!place.geometry) {
        $('#autocomplete-search').get(0).placeholder = 'Search for an Address';
    } else {
        $('#details').text(place.name);
    }

    return {
        'name': $('#autocomplete-search').val(),
        'long': place.geometry.location.lng(),
        'lat': place.geometry.location.lat()
    };
}

function showAdminMapLayer() {
    $.ajax({
        url: '/MapData/getRegions',
        method: 'POST',
        dataType: 'json',
        success: function (data) {
            var regions = JSON.parse(data);

            map.addSource('regions', {
                'type': 'geojson',
                'data': regions
            });

            map.addLayer({
                'id': 'regions-layer',
                'type': 'fill',
                'source': 'regions',
                'layout': {},
                'paint': {
                    'fill-color': '#e5c9c9',
                    'fill-opacity': 0.4
                }
            });

            map.addLayer({
                'id': 'region-names',
                'type': 'symbol',
                'source': 'regions', // reference the data source
                'layout': {
                    'text-field': '{name}',
                    'symbol-placement': 'point',
                    'text-anchor': 'center',
                }
            });
        }
    });
}

function initMap() {
    let activeFeature = null,
        titleLayers = null,
        popup = null,
        setActive = null,
        allowDeactivate = true,
        userMarker;

    mapboxgl.accessToken = 'pk.eyJ1IjoiaWFudGxzIiwiYSI6ImNqemh0dzRmbTB6ZW8zbHJzNXVzYXhmMHoifQ.040ImSzKrQ7ASbHABWWXbQ';

    let bounds = [
        [160.408431417656, -49.677977351135304], // Southwest coordinates
        [184.53357925420107, -31.668667084489257] // Northeast coordinates
    ];

    map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/streets-v8',
        // style: 'mapbox://styles/iantls/cjzhvy6bk33p71do3cycborpt',
        pitchWithRotate: false,
        maxBounds: bounds,
        attributionControl: false
    }),
        activeFeature = null,
        popup = new mapboxgl.Popup({
            closeButton: true,
            closeOnClick: false
        }),
        setActive = function (feature) {

            if (feature) {
                allowDeactivate = false
                window.setTimeout(function () {
                    allowDeactivate = true
                }, 100)

                // Fix for partial feature highlights: Get geometry data from source
                let geometry = feature.geometry;
                let sourceData = map.getSource('property-titles')._data; // ⚠️ _data is undocumented but works
                let fullFeature = sourceData.features.find(f =>
                    f.id === feature.properties.id || f.properties.id === feature.properties.id
                );
                if (fullFeature) {
                    geometry = fullFeature.geometry;
                }

                let source = map.getSource('highlight');
                if (source) {
                    source.setData({
                        'id': 'activefeature',
                        'type': 'Feature',
                        'geometry': {
                            'type': geometry.type,
                            'coordinates': geometry.coordinates
                        }
                    });
                } else {
                    map.addSource('highlight', {
                        'type': 'geojson',
                        'data': {
                            'id': 'activefeature',
                            'type': 'Feature',
                            'geometry': {
                                'type': geometry.type,
                                'coordinates': geometry.coordinates
                            }
                        }
                    });
                }

                // Highlight Fill
                if (!map.getLayer('highlight-fill')) {
                    map.addLayer({
                        'id': 'highlight-fill',
                        'type': 'fill',
                        'source': 'highlight', // reference the data source
                        'layout': {},
                        'paint': {
                            'fill-color': '#0080ff', // blue color fill
                            'fill-opacity': 0.5,
                        }
                    });
                }

                // Highlight Line
                if (!map.getLayer('highlight-outline')) {
                    map.addLayer({
                        'id': 'highlight-outline',
                        'type': 'line',
                        'source': 'highlight',
                        'layout': {},
                        'paint': {
                            'line-color': '#000',
                            'line-width': 2
                        }
                    });
                }
            } else {
                if (!allowDeactivate) return;
                if (map.getLayer('highlight-fill')) map.removeLayer('highlight-fill');
                if (map.getLayer('highlight-outline')) map.removeLayer('highlight-outline');
            }
        }
    popup.on('close', function () {
        setActive(false)
        $('.rural-map').removeClass('panelOpen');
    })

    popup.on('open', function () {
        $('.rural-map').addClass('panelOpen');
    })

    map.on('load', function () {
        let clickTimer = null,
            featureList = [];

        let currentUser = $('#userid').val();
        if (gtag && currentUser) {
            gtag('event', 'map_open', {
                'event_id': getEventId('l'),
                'member_id': currentUser.toString()
            });
        }

        //High Quality Satellite
        map.addSource('hd-aerial', {
            'type': 'raster',
            'tiles': [
                'https://basemaps.linz.govt.nz/v1/tiles/aerial/WebMercatorQuad/{z}/{x}/{y}.webp?api=d01hyyjfaxf7jmeqmyc3de0xrfz'
            ],
        });

        // Measurement stuff
        map.addSource('geojson', {
            'type': 'geojson',
            'data': measureFeatures
        });

        // Add styles to the map
        map.addLayer({
            id: 'measure-points',
            type: 'circle',
            source: 'geojson',
            paint: {
                'circle-radius': 5,
                'circle-color': '#000'
            },
            filter: ['in', '$type', 'Point']
        });
        map.addLayer({
            id: 'measure-lines',
            type: 'line',
            source: 'geojson',
            layout: {
                'line-cap': 'round',
                'line-join': 'round'
            },
            paint: {
                'line-color': '#000',
                'line-width': 2.5
            },
            filter: ['in', '$type', 'LineString']
        });

        /* Routing Tool code */
        if ($('#routeTool').length) {
            map.off('click').on('click', function (e) {
                // Reset
                if (coordFrom && coordTo) {
                    coordFrom = coordTo = null;
                    if (startMarker) startMarker.remove();
                    if (endMarker) endMarker.remove();
                    $('#routeInfo').css('display', 'none');
                    $('#routeStart').val('');
                    $('#routeEnd').val('');
                    if (map.getLayer('orsLayer')) {
                        map.removeLayer('orsLayer');
                    }
                }

                if ($('#routeTool').is(':visible') && $('#routeTool').hasClass('active')) {
                    if (!coordFrom) {
                        coordFrom = [e.lngLat.lng, e.lngLat.lat];
                        if (startMarker) startMarker.remove();
                        let startMarkerElement = createCustomMarker('fa-flag', 'startMarker');
                        startMarker = new mapboxgl.Marker(startMarkerElement)
                            .setLngLat(coordFrom)
                            .addTo(map);
                        $('#routeStart').val(coordFrom[1].toFixed(5) + ', ' + coordFrom[0].toFixed(5));
                    } else if (!coordTo) {
                        coordTo = [e.lngLat.lng, e.lngLat.lat];
                        if (endMarker) endMarker.remove();
                        let endMarkerElement = createCustomMarker('fa-flag-checkered', 'endMarker');
                        endMarker = new mapboxgl.Marker(endMarkerElement)
                            .setLngLat(coordTo)
                            .addTo(map);
                        $('#routeEnd').val(coordTo[1].toFixed(5) + ', ' + coordTo[0].toFixed(5));
                    }

                    if (coordFrom && coordTo) {
                        let options = {};
                        if ($('#vehicleType').is(':visible')) options = {'vehicle_type': $('#vehicleType').val()};
                        ORSQuery('directions', $('#routeType').val(), {
                            'start': coordFrom.toString(),
                            'end': coordTo.toString(),
                            'options': options
                        });
                    } else {
                        $('#routeInfo').css('display', 'none');
                        if (map.getLayer('orsLayer')) {
                            map.removeLayer('orsLayer');
                        }
                    }
                }
            });

            $('#routeType, #vehicleType').off('change').on('change', function () {
                let options = {};
                if($('#routeType').val() == 'driving-hgv') {
                    $('#vehicleType').show();
                    options = {'vehicle_type': $('#vehicleType').val()}
                } else {
                    $('#vehicleType').hide();
                }

                if (coordFrom && coordTo) {
                    ORSQuery('directions', $('#routeType').val(), {
                        'start': coordFrom.toString(),
                        'end': coordTo.toString(),
                        'options': options
                    });
                }
            });

            function generateRoute() {
                let options = {};
                $('#routeTool .option').each(function () {
                    let name = $(this).attr('name');
                    if($(this).val()) {
                        options[name] = $(this).val();
                    }
                });

                if (coordFrom && coordTo) {
                    ORSQuery('directions', $('#routeType').val(), {
                        'start': coordFrom.toString(),
                        'end': coordTo.toString(),
                        'options': options
                    });
                }

                return false;
            }

            $('#routeGenerate').off('click').on('click', generateRoute());

            $('#routeTool .option').on('change', function () {
                let options = {};
                if($('#routeType').val() == 'driving-hgv') {
                    $('#vehicleType').show();
                    options = {'vehicle_type': $('#vehicleType').val()}
                } else {
                    $('#vehicleType').hide();
                }

                if (coordFrom && coordTo) {
                    ORSQuery('directions', $('#routeType').val(), {
                        'start': coordFrom.toString(),
                        'end': coordTo.toString(),
                        'options': options
                    });
                }
            });
        }

        map.off('click').on('click', function (e) {
            setActive(null);
            clearRightPanel();

            /* Measurement */
            if(measureActive) {
                const features = map.queryRenderedFeatures(e.point, {
                    layers: ['measure-points']
                });

                // Remove the linestring from the group
                // so we can redraw it based on the points collection.
                if (measureFeatures.features.length > 1) measureFeatures.features.pop();

                // Clear the distance container to populate it with a new value.
                resultDiv.html('');
                distanceInner.css('display', 'none');

                // If a feature was clicked, remove it from the map.
                if (features.length) {
                    const id = features[0].properties.id;
                    measureFeatures.features = measureFeatures.features.filter(
                        (point) => point.properties.id !== id
                    );
                } else {
                    const point = {
                        'type': 'Feature',
                        'geometry': {
                            'type': 'Point',
                            'coordinates': [e.lngLat.lng, e.lngLat.lat]
                        },
                        'properties': {
                            'id': String(new Date().getTime())
                        }
                    };

                    measureFeatures.features.push(point);
                }

                if (measureFeatures.features.length > 1) {
                    linestring.geometry.coordinates = measureFeatures.features.map(
                        (point) => point.geometry.coordinates
                    );

                    measureFeatures.features.push(linestring);

                    // Populate the distanceContainer with total distance
                    const distance = turf.length(linestring);
                    resultDiv.html(`Total distance: ${distance.toLocaleString()}km`);
                    distanceInner.css('display', 'block');
                }

                map.getSource('geojson').setData(measureFeatures);
            }
        })

        map.off('mousemove').on('mousemove', function (e) {
            if(measureActive) {
                const features = map.queryRenderedFeatures(e.point, {
                    layers: ['measure-points']
                });
                // Change the cursor to a pointer when hovering over a point on the map.
                // Otherwise cursor is a crosshair.
                map.getCanvas().style.cursor = features.length
                    ? 'pointer'
                    : 'crosshair';
            } else {
                map.getCanvas().style.cursor = 'pointer';
            }
        });

        map.off('click', 'titles-layer').on('click', 'titles-layer', function(e) {
            featureList = e.features;

            setActive(false)

            // Change the cursor style as a UI indicator.
            map.getCanvas().style.cursor = 'pointer';

            clearTimeout(clickTimer);
            clickTimer = setTimeout(function () {
                activeFeature = featureList[0];
                let currentFeatures = featureList;

                setActive(activeFeature)

                // Ensure that if the map is zoomed out such that multiple
                // copies of the feature are visible, the popup appears
                // over the copy being pointed to.
                var coordinates = activeFeature.geometry.coordinates[0][0];
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }

                // Right panel rendering replaces the old per-feature HTML
                // string building. We just collect title IDs here for the
                // notes lookup and let renderRightPanel() build the DOM from
                // the <template> blocks in RightPanel.ss.
                let $prpIDs = [];
                for (let id in featureList) {
                    let feature = featureList[id];
                    try {
                        let data = feature.properties;
                        // TODO: I duplicated the 'prpID' line so that I can change it to save only the property titles. Make it work
                        if (data['title_no']) {
                            $prpIDs.push(data['title_no'].replaceAll('/', ''));
                        }
                    } catch (err) {
                        // Skip features missing expected properties; renderRightPanel handles its own fallbacks
                    }
                }

                // Render the right panel using <template> blocks defined in
                // RightPanel.ss. State (currentFeatures, activeId) is captured
                // in the prev/next click handlers below so cycling through
                // multiple features at the click point keeps working.
                let $data;
                let activeId = 0;

                renderRightPanel(currentFeatures, activeId);

                // setTimeout(() => {
                //     showFeatureLandUse(activeFeature);
                // });

                getPropertyNotes($prpIDs).then(function ($results) {
                    $data = $results;
                    addPropertyNotes($data);
                });

                setTimeout(function () {
                    watchPropertyNotes($prpIDs, $data);
                }, 1250);

                // Wire close button (uses setActive from this closure)
                $('#right-panel-close').off('click').on('click', function (event) {
                    event.preventDefault();
                    setActive(false);
                    clearRightPanel();
                });

                // Prev / next cycling within the right panel
                $('#right-panel')
                    .off('click', '.nextFeature')
                    .off('click', '.prevFeature')
                    .on('click', '.nextFeature', function (event) {
                        event.preventDefault();
                        activeId = (activeId + 1) % currentFeatures.length;
                        renderRightPanel(currentFeatures, activeId);
                        setActive(currentFeatures[activeId]);

                        // setTimeout(() => {
                        //     showFeatureLandUse(activeFeature);
                        // });

                        addPropertyNotes($data);
                        setTimeout(function () {
                            watchPropertyNotes($prpIDs, $data);
                        }, 1250);
                    })
                    .on('click', '.prevFeature', function (event) {
                        event.preventDefault();
                        activeId = activeId === 0 ? currentFeatures.length - 1 : activeId - 1;
                        renderRightPanel(currentFeatures, activeId);
                        setActive(currentFeatures[activeId]);

                        // setTimeout(() => {
                        //     showFeatureLandUse(activeFeature);
                        // });

                        addPropertyNotes($data);
                        setTimeout(function () {
                            watchPropertyNotes($prpIDs, $data);
                        }, 1250);
                    });

                featureList = [];
            });
        });

        //Just put a short delay on showing the map, otherwise we get weird flashing when Mapbox changes the layer properties
        window.setTimeout(function () {
            document.getElementById('map').classList.add('loaded')
        }, 100)

        if (typeof regions !== 'undefined' && location.search.match(/showBoundaries/)) {
            showAdminMapLayer();
        }

        $('#map-style-menu').show();

        // Get Company Layers
        $('#map-layer-menu .layer-checkbox').each(function () {
            if ($(this).is(':checked')) {
                companyLayers.push($(this).data('layer'));
            }
        });
    });

    map.addControl(new mapboxgl.AttributionControl({
        customAttribution: [
            '© Rural Mapping',
            '© <a target="_blank" href="//www.linz.govt.nz/linz-copyright">LINZ CC BY 4.0</a>',
            '© <a target="_blank" href="//www.linz.govt.nz/data/linz-data/linz-basemaps/data-attribution">Imagery Basemap contributors</a>',
        ]
    }));

    // TODO: REMOVE BEFORE DEPLOY
    // Center Map on Dunedin/Mosgiel
    if($('#dev').length) {
        map.flyTo({
            center: [170.42427755139147, -45.87351115670527],
            duration: 500,
            zoom: 12
        });
    }

    // This was to add the shadow on top of the map at the bottom and at the end but it screws up the map if its on top
    $('#map').append('<div class="shadow-1"></div>');
    $('#map').append('<div class="shadow-2"></div>');

    const userMarkerElement = document.createElement('div');
    userMarkerElement.className = 'userMarker';
    updateUserLocation();
    setInterval(updateUserLocation, 10000);

    function updateUserLocation() {
        if (!document.hidden) {
            if (!navigator.geolocation) {
                // Geolocation is not supported by this browser
                return;
            }

            navigator.permissions.query({ name: 'geolocation' }).then(result => {
                if (result.state === 'granted') {
                    const watchId = navigator.geolocation.watchPosition(
                        position => {
                            if (userMarker) {
                                userMarker.remove();
                            }
                            userMarker = new mapboxgl.Marker(userMarkerElement)
                                .setLngLat([position.coords.longitude, position.coords.latitude])
                                .addTo(map);
                        },
                        null,
                        {
                            enableHighAccuracy: true,
                            maximumAge: 0,
                            timeout: 10000
                        }
                    );
                }
            });
        }
    }
}

function getPropertyNotes($prpIDs) {
    return new Promise(function (resolve, reject) {
        let results;

        $.ajax({
            url: '/MapData/getPropertyNotes',
            method: 'POST',
            data: {prpTitles: $prpIDs},
            dataType: 'json',
            // async: true,
            success: function (data) {
                results = JSON.parse(JSON.stringify(data));
                resolve(results)
            },
            error: function (xhr, status, error) {
                // Optionally handle errors
                reject(error);
            }
        });
    });
}

// TODO: I duplicated the 'prpID' line so that I can change it to save only the property titles. Make it work
function addPropertyNotes($results) {
    // Originally rendered into the Mapbox popup; now into the right panel.
    let targetEle = $('#right-panel-content');
    let $prpTitle = targetEle.children('.prp-deets-container').find('.property-title').text();
    let $prpAddress = targetEle.children('.prp-deets-container').find('.prp-address').text();
    let $prpID = $prpTitle.replaceAll('/', '');
    // let $prpID = $prpTitle.replaceAll('/', '') + $prpAddress.replace(/\s+/g, '').trim().replaceAll(',', '');
    let text = '';

    $.each($results, function (key, value) {
        if ($prpID === key) {
            let $nContainer = $('.notes-container');
            if (!$nContainer.length) {
                text += '<div class="notes-container">'
                $nContainer = $('.notes-container');
            }

            $nContainer.empty();

            text += '<span><strong>Your Private Notes</strong></span>';

            $.each(value, function (key, value) {
                if (value['Fk'] === $prpID) {

                    let $dateObj = new Date(value['LastEdited']);
                    let $date = $dateObj.toString().substring(4, 21)

                    text += '<div class="prp-note">';
                    text += '<span class="note-date">' + $date + '</span>';

                    let $notes = value['Note'].split('\n');
                    $notes = $notes.filter(function (line) {
                        return line.trim() !== '';
                    });

                    text += '<div class="note">';

                    $.each($notes, function (key, value) {
                        text += '<p>' + value + '</p>'
                    });

                    text += '</div></div>'
                }
            });

            if (!$nContainer.length) {
                text += '</div>'
                targetEle.append(text);
            } else {
                $nContainer.append(text);
            }
        }
    });
}

// TODO: I duplicated the 'prpID' line so that I can change it to save only the property titles. Make it work
function watchPropertyNotes($prpIDs, $data) {
    let $parent = $('#right-panel-content').find('.prp-deets-container');
    let $form = $parent.find('.property-notes-form');
    let $firstClick = true;
    let $prpTitle = $parent.find('.property-title').text().replaceAll('/', '');
    let $prpAddress = $parent.find('.prp-address').text();
    let $prpID = $prpTitle;
    // let $prpID = $prpTitle + $prpAddress.replace(/\s+/g, '').trim().replaceAll(',', '');
    let $loadingCog = $parent.children('.cog-loading');

    $loadingCog.removeClass('cog-loading');

    $form.on('submit', function (event) {
        // if ($firstClick) {
        //     $firstClick = false;
        //     event.preventDefault();
        //     $parent.children('.property-notes-form').find('.animate').each(function () {
        //         if ($(this).hasClass('inactive')) {
        //             $(this).removeClass('inactive');
        //         }
        //
        //         if (!$(this).hasClass('run')) {
        //             $(this).addClass('run');
        //         }
        //     });
        // } else {
            event.preventDefault();
            let $text = $parent.find('textarea').val()
            let $fill_colour = $('select[name=fill_colour]').val() ?? '';

            $(this).parent().parent().find('textarea').val('');

            $.ajax({
                url: '/MapData/addPropertyNote',
                method: 'POST',
                data: {text: $text, prpTitle: $prpID, fill_colour: $fill_colour},
                dataType: 'json',
                success: function (data) {
                    let results = JSON.parse(JSON.stringify(data));
                    let $noteItem = '';


                    if ($('.notes-container').length) {
                        let $targetEle = $parent.parent().find('.notes-container');
                        let note = addNewNote(results, $noteItem);

                        if(note) {
                            $noteItem += addNewNote(results, $noteItem)

                            $targetEle.append($noteItem)
                        }
                    } else {
                        // Fallback: notes-container should always exist in
                        // RightPanel.ss, but keep this branch for safety.
                        let $targetEle = $('#right-panel-content');

                        let note = addNewNote(results, $noteItem);

                        if(note) {
                            $noteItem += '<div class="notes-container">'
                            $noteItem += addNewNote(results, $noteItem)
                            $noteItem += '</div>'

                            $targetEle.append($noteItem)
                        }
                    }

                    if (Array.isArray($data[$prpID])) {
                        $data[$prpID].unshift(results)
                        addPropertyNotes($data)
                    } else {
                        $data[$prpID] = [];
                        $data[$prpID].push(results)
                        addPropertyNotes($data)
                    }
                }
            });

            // if($fill_colour) {
                map.fire('moveend');
                map.triggerRepaint();
            // }
        // }
    });

    $('select[name="fill_colour"]').off('change').on('change', function () {
        let $fill_colour = $(this).val() ?? 'none';
        $(this).css('background-color', $fill_colour);
        let $prpID = $parent.find('.property-title').text().replaceAll('/', '');
        if($prpID) {
            userHighlights[$prpID] = $fill_colour;
        };

        $(this).closest('form').submit();
    })
}

function addNewNote($results, $noteItem) {
    if(!$results) return;

    let $dateObj = new Date($results['LastEdited']);
    let $date = $dateObj.toString().substring(4, 21)

    $noteItem += '<div class="prp-note">';
    $noteItem += '<span class="note-date">' + $date + '</span>';

    let $notes = $results['Note'].split('\n');
    $notes = $notes.filter(function (line) {
        return line.trim() !== '';
    });

    $noteItem += '<div class="note">';

    $.each($notes, function (key, value) {
        $noteItem += '<p>' + value + '</p>'
    });

    $noteItem += '</div></div>'

    return $noteItem;
}

function initMap2() {
    mapboxgl.accessToken = 'pk.eyJ1IjoiaWFudGxzIiwiYSI6ImNqemh0dzRmbTB6ZW8zbHJzNXVzYXhmMHoifQ.040ImSzKrQ7ASbHABWWXbQ';
    let map2 = new mapboxgl.Map({
        container: 'map2',
        style: 'mapbox://styles/iantls/cjzhvy6bk33p71do3cycborpt',
        interactive: false
    })

    let bounds = [
        [168.89459356400425, -46.12433933615997], // [west, south]
        [169.11969378185665, -45.98244661486653] // [east, north]
    ];
    map2.setMaxBounds(bounds);
    map2.setMaxZoom(11.960626351946912);
    map2.setMinZoom(11.960626351946912);

    map2.on('load', function () {
        //Just put a short delay on showing the map, otherwise we get weird flashing when Mapbox changes the layer properties
        window.setTimeout(function () {
            document.getElementById('map2').classList.add('loaded')
        }, 100)
    })

    // This is to add shadow at the top and bottom of the map
    $('#map2').append('<div class="shadow-1"></div>');
    $('#map2').append('<div class="shadow-2"></div>');
}

function setEventListeners() {
    $('a.spot-link').off('click').on('click', function (e) {
        if (gtag) {
            gtag('event', 'spot_clicked', {
                'event_id': getEventId('c'),
                'spot_id': $(this).data('id').toString()
            });
        }
    });
}

// FIXME: Unneeded after switching to Linz data?
function getUniqueFeatures(features, comparatorProperty) {
    const uniqueIds = new Set();
    const uniqueFeatures = [];
    for (const feature of features) {
        let title = cleanJSON(feature.properties.title);
        try {
            let data = JSON.parse(title.toString());
            const id = data[comparatorProperty];
            if (!uniqueIds.has(id)) {
                uniqueIds.add(id);
                uniqueFeatures.push(feature);
            }
        } catch (e) {
            console.log('Couldn\'t find property information');
        }
    }
    return uniqueFeatures;
}

function cleanJSON(json) {
    let cleanJSON = json.replace(/[\r\n]+/, '\\n')
        .replace(/\u00c4\u0081/g, 'ā')
        .replace(/\u00c4\u20ac/g, 'Ā')
        .replace(/\u00c4\u201c/g, 'ē')
        // .replace(/\u00c4\u20ac/g, 'E')
        .replace(/\u00c4\u00ab/g, 'ī')
        // .replace(/\u00c4\u00aa/g, 'Ī')
        .replace(/\u00c5\u008d/g, 'ō')
        .replace(/\u00c5\u0152/g, 'Ō')
        .replace(/\u00c5\u00ab/g, 'ū');
    // .replace(/\u00c5\u00aa/g, 'Ū');

    cleanJSON = cleanJSON.replace(/"([^"]*)":"(.*?)"([,}])/g, function (match, p1, p2, p3) {
        // Escape quotes within the value
        const escapedValue = p2.replace(/"/g, '\\"');
        return `"${p1}":"${escapedValue}"${p3}`;
    });

    return cleanJSON;
}

function ORSQuery(service, endpoint, parameters) {
    const orsKey = '5b3ce3597851110001cf6248621f87635d974d3f8a9648e6c402ce83';
    let url = 'https://api.openrouteservice.org/v2/';
    url += service + '/' + endpoint; //+'?api_key='+orsKey;

    let data = {
        'api_key': orsKey,
    };

    $.each(parameters, function (key, value) {
        data[key] = value;
    });

    $.when($.ajax({
        url: url,
        method: 'GET',
        data: data,
        dataType: 'json',
        error: function (xhr, status, error) {
            console.log(xhr.responseText);
        }
    })).then(function (result) {
        showRoute(result.features[0]);
    });
}

function showRoute(feature) {
    let source = map.getSource('orsSource');
    if (source) {
        source.setData({
            'id': 'orsSource',
            'type': 'Feature',
            'geometry': {
                'type': feature.geometry.type,
                'coordinates': feature.geometry.coordinates
            }
        });
    } else {
        map.addSource('orsSource', {
            'type': 'geojson',
            'data': {
                'id': 'orsSource',
                'type': 'Feature',
                'geometry': {
                    'type': feature.geometry.type,
                    'coordinates': feature.geometry.coordinates
                }
            }
        });
    }

    // Highlight Fill
    if (!map.getLayer('orsLayer')) {
        map.addLayer({
            'id': 'orsLayer',
            'type': 'line',
            'source': 'orsSource', // reference the data source
            'layout': {},
            'line-cap': 'round',
            'paint': {
                'line-color': '#0080ff', // blue color fill
                'line-opacity': 1,
                'line-width': 3,
            }
        });
    }

    let routeInfo = feature.properties;
    let minutes = Math.round(routeInfo.summary.duration / 60);
    let hours = Math.floor(routeInfo.summary.duration / 3600);
    let remainingMinutes = minutes % 60;
    let time = remainingMinutes + ' min';
    if (hours > 0) {
        if (hours > 1) {
            time = (hours + ' hours ').concat(time);
        } else {
            time = (hours + '1 hour ').concat(time);
        }
    }

    $('#routeDistance').html((routeInfo.summary.distance / 1000).toFixed(1) + ' Km')
    $('#routeTime').html(' (' + time  + ')')
    $('#routeInfo').css('display', 'flex');

    // Zoom to the Route location. The map is full-width and BOTH panels
    // overlay it without resizing it, so pad fitBounds for whichever panels
    // are currently open. This keeps the route + its start/end markers
    // inside the visible area instead of tucked under a panel.
    const leftPanelOpen = !$('#left-panel-wrapper').hasClass('is-collapsed');
    const rightPanelOpen = $('.rural-map').hasClass('right-panel-open');
    map.fitBounds([
            [feature.bbox[0], feature.bbox[1]],
            [feature.bbox[2], feature.bbox[3]],
        ],
        {
            padding: {
                top: 60,
                bottom: 60,
                left: leftPanelOpen ? 340 : 60,   // 320px panel + breathing room
                right: rightPanelOpen ? 400 : 60  // 360px panel + breathing room
            }
        });
}

let propertyAddresses = [];
let propertyTitles = [];
let companyFeatures = [];
var activeClosure = null;
function fetchFeatures(bounds, zoom) {
    let bbox = [
        bounds.getWest(),
        bounds.getSouth(),
        bounds.getEast(),
        bounds.getNorth()
    ].join(',');

    let filterBbox = [
        bounds.getNorth(),
        bounds.getWest(),
        bounds.getSouth(),
        bounds.getEast()
    ].join(',');

    propertyAddresses = [];
    propertyTitles = [];
    companyFeatures = [];

    showToast();

    const closureId = Math.random() * Math.random()
    activeClosure = closureId

    if(zoom >= zoomLevels.addresses) {
        fetchStreetAddresses(bbox).then(features => {
            if (activeClosure == closureId) {
                propertyAddresses = features;

                if (propertyTitles.length) {
                    linkAddressesToTitles();
                    loadAddressesToMap();
                }

                moveLayerToTop('addresses-layer');
            }
        });
    }

    // Build company promise up front so fetchTitles can wait on it
    let companyPromise = Promise.resolve();
    activeMarkers.forEach(marker => marker.remove());
    activeMarkers = [];
    if(zoom >= zoomLevels.markers && companyLayers.length) {
        companyFeatures = [];
        const allPromises = companyLayers.map(layer =>
            fetchCompanyFeatures(bbox, layer).then(features => {
                companyFeatures[layer] = { features: features };
            })
        );
        companyPromise = Promise.all(allPromises);
    }

    if(zoom >= zoomLevels.default) {
        const lucasPromise = (zoom >= zoomLevels.lucas && showLandUse)
            ? fetchLUCASData(bbox)
            : Promise.resolve(null);

        Promise.all([
            fetchTitles(filterBbox),
            lucasPromise,
            companyPromise
        ]).then(([titles, layers]) => {
            if (activeClosure !== closureId) return;

            propertyTitles = titles;

            // Link company features to titles now that both are ready
            companyFeatures.forEach(set => {
                if (set.features.length) linkCompanyFeaturesToTitles(set.features);
            });

            if (propertyAddresses.length) {
                linkAddressesToTitles();
                loadAddressesToMap();
            }

            if (layers !== null) {
                lucasLayers = layers || {};
                updatePropertyTypeFilterVisibility(lucasLayers);
            } else {
                updatePropertyTypeFilterVisibility(null);
            }

            // Called exactly once
            loadTitlesToMap(filteredTitles());
            moveLayerToTop('lucas-layer');
            moveLayerToTop('addresses-layer');
            showToast(false);
        });
    } else {
        showToast(false);
    }
}

function loadTitlesToMap(features) {
    if (map.getSource('property-titles')) {
        map.getSource('property-titles').setData({
            'type': 'FeatureCollection',
            'features': features
        });
        map.setLayoutProperty('titles-layer', 'visibility', 'visible');
    } else {
        map.addSource('property-titles', {
            'type': 'geojson',
            'data': {
                'type': 'FeatureCollection',
                'features': features
            }
        });

        map.addLayer({
            'id': 'titles-layer',
            'type': 'fill',
            'source': 'property-titles',
            'paint': {
                'fill-color': ['coalesce', ['get', 'fill_colour'], '#e5c9c9'],
                'fill-opacity': 0.5,
            },
        });
    }
}

function loadLucasDataToMap(features) {
    if (map.getSource('lucas-data')) {
        map.getSource('lucas-data').setData({
            'type': 'FeatureCollection',
            'features': features
        });
        map.setLayoutProperty('lucas-layer', 'visibility', 'visible');
        map.setLayoutProperty('lucas-outline', 'visibility', 'visible');
    } else {
        map.addSource('lucas-data', {
            'type': 'geojson',
            'data': {
                'type': 'FeatureCollection',
                'features': features
            }
        });

        map.addLayer({
            'id': 'lucas-layer',
            'type': 'fill',
            'source': 'lucas-data',
            'background-opacity': 0,
            'paint': {
                // 'fill-color': ['coalesce', ['get', 'fill_colour'], '#C9C9E5'],
                'fill-pattern': 'pattern',
                'fill-opacity': 0.5,
            },
        });

        map.addLayer({
            'id': 'lucas-outline',
            'type': 'line',
            'source': 'lucas-data',
            'background-opacity': 0,
            'paint': {
                'line-color': '#C9C9E5',
                'line-width': 2,
            },
        });
    }
}

function loadAddressesToMap() {
    if (map.getSource('property-addresses')) {
        map.getSource('property-addresses').setData({
            'type': 'FeatureCollection',
            'features': propertyAddresses
        });

        map.setLayoutProperty('addresses-layer', 'visibility', 'visible');
    } else {
        map.addSource('property-addresses', {
            'type': 'geojson',
            'data': {
                'type': 'FeatureCollection',
                'features': propertyAddresses
            }
        });

        map.addLayer({
            'id': 'addresses-layer',
            'type': 'symbol',
            'source': 'property-addresses',
            'layout': {
                'text-field': ['get', 'full_address_number'],
                'text-size': 12,
                'text-anchor': 'center',
                'symbol-placement': 'point',
            },
            'paint': {
                'text-color': '#000000'
            }
        });
    }
}

function hideFeatures(zoom) {
    if (map.getLayer('addresses-layer') && zoom < zoomLevels.addresses) {
        map.setLayoutProperty('addresses-layer', 'visibility', 'none');
    }

    if (map.getLayer('titles-layer') && zoom < zoomLevels.default) {
        map.setLayoutProperty('titles-layer', 'visibility', 'none');
    }

    if (activeMarkers.length && zoom < zoomLevels.markers) {
        activeMarkers.forEach(marker => marker.remove());
    }
}

/* Fetch and return Street address numbers */
function fetchStreetAddresses(bbox) {
    let url = `/wfs/layer-123113/?service=wfs&version=2.0.0&request=GetFeature&typeName=layer-123113&bbox=${bbox},EPSG:4326&outputFormat=application/json`;

    return fetch(url)
        .then(response => response.json())
        .then(data => {
            return data.features.map(feature => ({
                type: feature.type,
                geometry: feature.geometry, // Keep geometry
                properties: {
                    full_address_number: feature.properties.full_address_number,
                    // address_number: feature.properties.address_number,
                    // address_number_suffix: feature.properties.address_number_suffix,
                    // full_address: feature.properties.full_address,
                    full_address: feature.properties.full_address_number + ' ' + feature.properties.full_road_name,
                }
            }));
        })
        .catch(error => {
            console.error('Error fetching WFS data:', error);
            return []; // Prevent errors by returning an empty array
        });
}

/* LINZ Titles */
function fetchTitles(bbox) { let url = `/wfs/layer-50805/?service=wfs&version=2.0.0&request=GetFeature&typeName=layer-50805&outputFormat=application/json&SRSName=EPSG:4326&boundingbox=${bbox}`;
    return fetch(url)
        .then(response => response.json())
        .then(data => {
            let debug = true;
            return data.features
                .filter(feature => {
                    // const area = getLandAreaFromTitle(feature); // Ha
                    return isFeatureShown(feature);
                })
                .map(feature => {
                    const titleNo = feature.properties.title_no.replaceAll('/', '');
                    const fillColour = userHighlights[titleNo];

                    return {
                        type: feature.type,
                        geometry: feature.geometry,
                        properties: {
                            ...feature.properties,
                            ...(fillColour ? { fill_colour: fillColour } : {})
                        }
                    };
            });
        })
        .catch(error => {
            console.error('Error fetching WFS data:', error);
            return [];
        });
}

function isFeatureShown(feature) {
    const area = turf.area(feature.geometry) / 10000; // Ha

    const minArea = $("#property-size").slider("values", 0);
    const maxArea = $("#property-size").slider("values", 1);

    if(maxArea == 1000) {
        return area >= minArea;
    } else {
        return area >= minArea && area <= maxArea;
    }
}

const LUCAS_TYPE_LABELS = {
    'forest':               'Forest',
    'grassland':            'Grassland',
    'grassland-dairy':      'Grassland (Dairy)',
    'grassland-non-dairy':  'Grassland (Non-Dairy)',
    'grassland-ungrazed':   'Grassland (Ungrazed)',
    'cropland':             'Cropland',
    'wetland':              'Wetland',
    'settlements':          'Settlements'
};

/* =====================================================================
 * LUCAS land-use — lazy, per-type architecture
 * ---------------------------------------------------------------------
 * Up-front we ONLY bucket the WFS response into per-type arrays — no
 * intersect/area work for any titles yet. The expensive geometry tests
 * only run when:
 *   (a) the user ticks a Property Type checkbox  → titleMatchesAnyType()
 *       runs the test for each visible title, but ONLY against the
 *       checked layer(s); OR
 *   (b) the user clicks a title and the right panel opens →
 *       getTitleLandUseTypes() runs the test once, for that single
 *       title, across every loaded layer.
 *
 * Positive matches are cached by title ID for the session, so panning
 * back to an area we've already tagged costs nothing. Negatives are
 * NOT cached because a later, wider fetch may bring in a LUCAS polygon
 * we hadn't seen — a negative could go stale, a positive can't.
 * ===================================================================== */

// Bucketed LUCAS features for the current bbox: { slug: [feature, ...] }.
// Reset each time fetchLUCASData resolves.
let lucasLayers = {};

// Positive-match cache: titleLandUseCache[titleId] = { forest: true, ... }
const titleLandUseCache = {};

function titleId(title) {
    if (!title) return null;
    if (title.id) return String(title.id);
    if (title.properties && title.properties.id) return String(title.properties.id);
    return null;
}

/* Fetch LUCAS data and bucket it into per-type collections so checkbox
 * filters only have to scan their own layer. Returns { slug: [features] }. */
function fetchLUCASData(bbox) {
    let url = `/wfs/layer-117733/?service=wfs&version=2.0.0&request=GetFeature&typeName=layer-117733&srsName=EPSG:4326&bbox=${bbox},EPSG:4326&outputFormat=application/json`;

    return fetch(url)
        .then(response => response.json())
        .then(data => {
            const features = (data && data.features) || [];
            const layers = {};
            features.forEach(feature => {
                const type = getLUCASPropertyType(feature.properties);
                if (!type) return;
                if (!layers[type]) layers[type] = [];
                layers[type].push(feature);
            });
            $.each(layers, (type, layer) => {
                let col = turf.featureCollection(layer);
                layers[type] = turf.combine(col).features;
            })
            return layers;
        })
        .catch(error => {
            console.error('Error fetching LUCAS WFS data:', error);
            return {};
        });
}

/* Hide every Property Type checkbox that has no LUCAS features in the
 * current view. Unchecks any filter that just lost its data so the map
 * doesn't get stuck filtering on something with nothing to match. */
function updatePropertyTypeFilterVisibility(layers) {
    let anyVisible = false;
    let changed = false;
    $('[data-field="property-type"] input[data-property-type]').each(function () {
        const slug = $(this).attr('data-property-type');
        const hasFeatures = !!(layers && layers[slug] && layers[slug].length);
        const $label = $(this).closest('.rm-checkbox');
        $label.toggle(hasFeatures);
        if (hasFeatures) anyVisible = true;
        if (!hasFeatures && this.checked) {
            this.checked = false;
            changed = true;
        }
    });
    $('[data-field="property-type"]').toggle(anyVisible);
    if (changed) applyOwnerFilter();
}

/* Core overlap test: does `title` overlap any of `lucasFeatures` by at
 * least `threshold` of its area? Bbox pre-check + booleanIntersects +
 * intersect, early-exits on first positive. */
function titleOverlapsAnyLucasFeature(
    title,
    titleBbox,
    titleArea,
    lucasFeatures,
    threshold
) {
    if (!titleArea || !lucasFeatures?.length) {
        return false;
    }

    for (let i = 0; i < lucasFeatures.length; i++) {
        const lucas = lucasFeatures[i];

        if (!lucas?.geometry) {
            continue;
        }

        // Cache bbox
        let lcBbox = lucas._bbox;
        if (!lcBbox) {
            lcBbox = turf.bbox(lucas);
            lucas._bbox = lcBbox;
        }

        // Fast bbox reject
        if (
            titleBbox[0] > lcBbox[2] ||
            titleBbox[2] < lcBbox[0] ||
            titleBbox[1] > lcBbox[3] ||
            titleBbox[3] < lcBbox[1]
        ) {
            continue;
        }

        // Cheap geometry reject
        if (!turf.booleanIntersects(title, lucas)) {
            continue;
        }

        // Expensive clip
        let intersection;
        try {
            intersection = turf.intersect(
                turf.featureCollection([title, lucas])
            );
        } catch {
            continue;
        }

        if (!intersection) {
            continue;
        }

        const intersectArea = turf.area(intersection);

        if (intersectArea > 0 &&
            (intersectArea / titleArea) >= threshold
        ) {
            return true;
        }
    }

    return false;
}

/* Filter path: returns true iff `title` overlaps any LUCAS layer in
 * `types` by >= 20%. Consults the positive cache before computing. */
function titleMatchesAnyType(title, types) {
    if (!types || !types.length) return true;
    if (typeof turf === 'undefined') return false;

    const id = titleId(title);
    const cache = id ? (titleLandUseCache[id] = titleLandUseCache[id] || {}) : {};

    // Cheap pass: any positive already cached?
    for (let i = 0; i < types.length; i++) {
        if (cache[types[i]] === true) return true;
        else if (cache[types[i]] === false) return false;
    }

    let titleArea, titleBbox;
    try {
        titleArea = turf.area(title.geometry);
        titleBbox = turf.bbox(title);
    } catch (e) { return false; }
    if (!titleArea || !titleBbox) return false;

    for (let i = 0; i < types.length; i++) {
        const type = types[i];
        if (cache[type] === true) return true;
        const layer = lucasLayers[type];
        if (!layer || !layer.length) continue;
        if (titleOverlapsAnyLucasFeature(title, titleBbox, titleArea, layer, 0.2)) {
            cache[type] = true;
            return true;
        } else {
            cache[type] = false;
        }
    }
    return false;
}

/* Right-panel path: returns the full set of land-use slugs that this
 * single title overlaps. Caches positives along the way. */
function getTitleLandUseTypes(title) {
    if (typeof turf === 'undefined') return [];
    const id = titleId(title);
    const cache = id ? (titleLandUseCache[id] = titleLandUseCache[id] || {}) : {};

    let titleArea, titleBbox;
    try {
        titleArea = getLandAreaFromTitle(title);
        titleBbox = turf.bbox(title);
    } catch (e) { return []; }
    if (!titleArea || !titleBbox) return [];

    const result = [];
    Object.keys(lucasLayers).forEach(type => {
        if (cache[type] === true) {
            result.push(type);
            return;
        }
        const layer = lucasLayers[type];
        if (!layer || !layer.length) return;
        if (titleOverlapsAnyLucasFeature(title, titleBbox, titleArea, layer, 0.2)) {
            cache[type] = true;
            result.push(type);
        }
    });
    return result;
}

function getLUCASPropertyType(lucasProps) {
    if (!lucasProps) return null;

    const lucid = parseInt(lucasProps.LUCID_2020, 10);

    if (Number.isNaN(lucid)) return null;

    if (lucid >= 71 && lucid <= 73) {
        return 'forest';
    }

    if (lucid >= 74 && lucid <= 76) {
        const subid = parseInt(lucasProps.SUBID_2020, 10);

        if (subid === 502) return 'grassland-dairy';
        if (subid === 503) return 'grassland-non-dairy';
        if (subid === 504) return 'grassland-ungrazed';

        return 'grassland';
    }

    if (lucid === 77 || lucid === 78) {
        return 'cropland';
    }

    if (lucid === 79 || lucid === 80) {
        return 'wetland';
    }

    if (lucid === 81) {
        return 'settlements';
    }

    return null;
}

// Store markers so we can clear them on updates
let activeMarkers = [];

function fetchCompanyFeatures(bbox, id) {
    let url = `/map/features?bbox=${bbox}&layer=${id}`;

    // let url = `/map/features?bbox=${bbox}&layers=${encodeURIComponent(companyLayers.join(','))}`;

    return fetch(url)
        .then(response => response.json())
        .then(data => {
            let allFeatures = [];

            if (data) {
                Object.entries(data).forEach(([layerName, featureCollection]) => {
                    featureCollection.features.forEach(feature => {
                        const coords = feature.geometry.coordinates;
                        const props = feature.properties;

                        if (feature.geometry.type === 'Point') {
                            const colour = props.point_colour || '#00AA00';

                            // Create custom marker element
                            const markerElement = createCustomMarker('fa-map-marker-alt', 'marker');
                            markerElement.style.color = colour;

                            if (props.url) {
                                markerElement.style.cursor = 'pointer';
                                markerElement.addEventListener('click', () => {
                                    window.open(props.url, '_blank');
                                });
                            }

                            const marker = new mapboxgl.Marker(markerElement)
                                .setLngLat(coords)
                                .addTo(map);

                            if (props.name) {
                                markerElement.setAttribute('title', props.name)
                            }

                            activeMarkers.push(marker);
                        }

                        allFeatures.push(feature);
                    });

                    if (!companyFeatures[layerName]) {
                        companyFeatures[layerName] = {
                            type: 'FeatureCollection',
                            features: []
                        };
                    }

                    // Add or replace features
                    companyFeatures[layerName].features = allFeatures;
                });
            }

            return allFeatures;
        })
        .catch(error => {
            console.error('Error fetching WFS data:', error);
            return [];
        });
}

// Point-in-polygon function (works for simple and multi-polygons)
function isPointInPolygon(point, polygon) {
    const [x, y] = point.coordinates;

    // If MultiPolygon, flatten into array of polygons
    const polygons = polygon.type === 'Polygon'
        ? [polygon.coordinates]
        : polygon.coordinates;

    return polygons.some(ringSet => {
        // Exterior ring is ringSet[0]
        const ring = ringSet[0];
        let inside = false;
        for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
            const xi = ring[i][0], yi = ring[i][1];
            const xj = ring[j][0], yj = ring[j][1];

            const intersect = ((yi > y) !== (yj > y)) &&
                (x < (xj - xi) * (y - yi) / (yj - yi + 0.0000001) + xi);
            if (intersect) inside = !inside;
        }
        return inside;
    });
}

function linkAddressesToTitles() {
    let filteredAddress = [];
    propertyAddresses.forEach(addressFeature => {
        const point = addressFeature.geometry;

        const matchingTitle = propertyTitles.find(titleFeature =>
            isPointInPolygon(point, titleFeature.geometry)
        );

        if (matchingTitle) {
            matchingTitle.properties = {
                ...matchingTitle.properties,
                ...addressFeature.properties
            }
            filteredAddress.push(addressFeature)
        }
    });

    propertyAddresses = filteredAddress;
}

function linkCompanyFeaturesToTitles(features) {
    features.forEach(feature => {
        const point = feature.geometry;

        const matchingTitle = propertyTitles.find(titleFeature =>
            isPointInPolygon(point, titleFeature.geometry)
        );

        if (matchingTitle) {
            let titleNo = matchingTitle.properties.title_no.replaceAll('/', '');
            let fillColour = userHighlights[titleNo];

            matchingTitle.properties = {
                ...matchingTitle.properties,
                ...feature.properties
            }
            if(fillColour) matchingTitle.properties.fill_colour = fillColour; // Reapply Customer defined colour
        }
    });
}

function createCustomMarker(iconClass, className) {
    const el = document.createElement('div');
    el.className = className;

    const icon = document.createElement('i');
    icon.className = `fa ${iconClass}`;

    el.appendChild(icon);

    el.style.fontSize = '24px'; // adjust as necessary
    el.style.color = '#000'; // adjust as necessary

    return el;
}

function showToast(active = true) {
    if (active) {
        $('#loadingToast').addClass('show');
    } else {
        $('#loadingToast').removeClass('show');
    }
}

function moveLayerToTop(layerId) {
    if(map.getLayer(layerId)) {
        const layers = map.getStyle().layers.map(l => l.id);
        const lastLayerId = layers[layers.length - 1];

        // Only move if it's not already on top
        if (layerId !== lastLayerId) {
            map.moveLayer(layerId);
        }
    }
}

$(document).ready(function () {
    $('.layer-toggle-btn').on('click', function () {
        const $drawer = $('#map-layer-menu .layer-drawer');
        $drawer.slideToggle(200);
    });

    // Default left panel closed on mobile
    if(window.screen.width <= 680) {
        const $wrapper = $('#left-panel-wrapper');
        $wrapper.toggleClass('is-collapsed');
        $('#left-panel-toggle').find('i')
            .toggleClass('fa-chevron-left')
            .toggleClass('fa-chevron-right');
    }
});


$('.close-btn').on('click', function () {
    let target = $(this).data('target');
    $('.option.'+target).trigger('click');
});

// Owner filter now lives inside the left panel. updateFilterBar mirrors the
// current searchString into the input value and toggles the clear button +
// hint label that say "Only showing <name>".
function updateFilterBar() {
    const input = document.getElementById('owner-filter-input');
    const clearBtn = document.getElementById('owner-filter-clear');
    const labelHint = document.getElementById('owner-filter-label');
    const nameSpan = document.getElementById('owner-filter-name');
    if (!input) {
        $('#owner-filter-wrapper').hide();
        return;
    }

    if (searchString) {
        $('#owner-filter-wrapper').show();
        if (input.value !== searchString) input.value = searchString;
        if (clearBtn) clearBtn.style.display = '';
        if (labelHint) labelHint.style.display = '';
        if (nameSpan) nameSpan.textContent = searchString;
    } else {
        $('#owner-filter-wrapper').hide();
        if (input.value) input.value = '';
        if (clearBtn) clearBtn.style.display = 'none';
        if (labelHint) labelHint.style.display = 'none';
    }
}

function filterByOwner(el) {
    const fullOwner = el.dataset.owner;
    if (!fullOwner) return;
    searchString = fullOwner.split(',')[0].trim();
    updateFilterBar();
    applyOwnerFilter();
}

// Keyup on owner input — update searchString and retrigger filter
$(document).on('keyup', '#owner-filter-input', function () {
    searchString = $(this).val().trim();
    applyOwnerFilter();
    updateFilterBar();
});

// Clear filter
$(document).on('click', '#owner-filter-clear', function (e) {
    e.preventDefault();
    searchString = '';
    updateFilterBar();
    applyOwnerFilter();
});

// Filter button inside right-panel owner rows (replaces the old inline
// "Filter" link that used inline onclick="filterByOwner(this)").
$(document).on('click', '#right-panel [data-bind="owner-filter"]', function (e) {
    e.preventDefault();
    filterByOwner(this);
});

function nameMatch(name, search) {
    let match = true;
    const searchWords = search.toLowerCase().split(' ');
    const nameWords = name.toLowerCase().split(' ');

    for (let i = 0; i < searchWords.length; i++) {
        if (!nameWords.includes(searchWords[i])) {
            match = false;
            break;
        }
    }

    return match;
}

function applyOwnerFilter() {
    // Despite the name this re-applies both the owner search AND the
    // Property Type checkbox filter. Kept named applyOwnerFilter() so all
    // the existing callers (owner-filter-input keyup, clear button, the
    // popup's filter-by-owner link) keep working without changes.
    loadTitlesToMap(filteredTitles());
}

/**
 * Return the property-type slugs that are currently ticked in the left
 * panel's Property Type group. An empty array means "no filter active"
 * so every title should pass.
 */
function getCheckedPropertyTypes() {
    const checked = [];
    $('[data-field="property-type"] input[type="checkbox"][data-property-type]:checked').each(function () {
        const slug = $(this).attr('data-property-type');
        if (slug) checked.push(slug);
    });
    return checked;
}

function filteredTitles() {
    let titles = propertyTitles;

    // Owner search filter
    if (searchString) {
        titles = titles.filter(feature => {
            const ownersRaw = feature.properties && feature.properties.owners;
            if (!ownersRaw) return false;
            const owners = ownersRaw.split(',');
            return owners.some(o => nameMatch(o.trim(), searchString));
        });
    }

    // Property Type filter — OR match. If no boxes ticked, no restriction.
    // titleMatchesAnyType consults the per-title positive cache before
    // running any turf work, so toggling the same filter twice is O(1).
    const checkedTypes = getCheckedPropertyTypes();

    if (checkedTypes.length) {
        let features = [];
        for (let i = 0; i < checkedTypes.length; i++) {
            features.push(lucasLayers[checkedTypes[i]][0]);
        }
        loadLucasDataToMap(features);
        // titles = titles.filter(t => titleMatchesAnyType(t, checkedTypes));
    } else {
        loadLucasDataToMap({});
    }
    $('.rm-checkbox-list').removeClass('loading');

    return titles;
}


/* =====================================================================
 * Right-panel rendering
 * ---------------------------------------------------------------------
 * Replaces the Mapbox popup that used to be built as an HTML string at
 * map click time. Markup lives in <template> blocks defined in
 * RightPanel.ss; this module clones them and fills in the bound nodes.
 * ===================================================================== */

// Full palette preserved from the original popup. Rendered as a row of
// clickable swatches (per user pref instead of the design's 5 + "+").
let defaultColors = [
    "#e63946",
    "#1d3557",
    "#2a9d8f",
    "#f4a261",
    "#6a4c93",
    "#00bcd4",
    "#f97316",
    "#a3e635",
    "#ec4899",
    "#64748b"
];

let featureColors = {};

/*
// Build a reverse lookup: hex -> custom name
let hexToCustomName = {};
$.each(customColors, function(customName, hex) {
    hexToCustomName[hex] = customName;
});

// Build featureColors, preferring custom names when the hex matches
$.each(defaultColors, function(defaultName, hex) {
    let key = hexToCustomName[hex] || defaultName;
    featureColors[key] = hex;
});
*/

let legendEditMode = false; // manual toggle via the pencil icon, persists across panel re-renders

function rebuildFeatureColours() {
    featureColors = {};
    defaultColors.forEach(function (hex) {
        featureColors[hex] = customColors[hex] || ''; // blank if never named
    });
}
rebuildFeatureColours();

// True as soon as any colour's name has drifted from its default, per-hex
function hasCustomColourNames() {
    return Object.keys(customColors).length > 0;
}

function ownerInitials(name) {
    if (!name) return '';
    return name.trim().split(/\s+/)
        .map(w => w.charAt(0).toUpperCase())
        .slice(0, 2)
        .join('');
}

/**
 * Render the right side panel for a list of clicked features.
 *
 * @param {Array}  features Features from the titles-layer click.
 * @param {Number} activeId Index into features that should be displayed.
 */
function renderRightPanel(features, activeId) {
    const panel = document.getElementById('right-panel');
    const content = document.getElementById('right-panel-content');
    if (!panel || !content) return;

    if (!features || !features.length) {
        clearRightPanel();
        return;
    }

    const feature = features[activeId];
    if (!feature) return;
    const data = feature.properties || {};

    // ----- Header: address + locality -----
    const addressEl = panel.querySelector('[data-bind="prp-address"]');
    const locationWrap = panel.querySelector('[data-bind="prp-location"]');
    const locationText = panel.querySelector('[data-bind="prp-location-text"]');
    if (addressEl) {
        addressEl.textContent = data.full_address || data.full_address_number || 'Property Details';
    }
    const localityParts = [];
    if (data.suburb_locality) localityParts.push(data.suburb_locality);
    if (data.town_city && data.town_city !== data.suburb_locality) localityParts.push(data.town_city);
    if (!localityParts.length && data.territorial_authority) localityParts.push(data.territorial_authority);
    if (locationText) locationText.textContent = localityParts.join(', ');
    if (locationWrap) locationWrap.style.display = localityParts.length ? '' : 'none';

    // ----- Prev / next nav -----
    const nav = panel.querySelector('[data-bind="prp-nav"]');
    if (nav) {
        if (features.length > 1) {
            nav.style.display = '';
            const counter = nav.querySelector('[data-bind="prp-nav-counter"]');
            if (counter) counter.textContent = (activeId + 1) + ' of ' + features.length;
        } else {
            nav.style.display = 'none';
        }
    }

    // ----- Clone the detail template -----
    const tpl = document.getElementById('prp-detail-template');
    if (!tpl) return;
    const detail = tpl.content.firstElementChild.cloneNode(true);

    // ----- Land area (computed from estate_description) -----
    let ha = getLandAreaFromTitle(feature);
    setText(detail, 'prp-area', ha ? (ha + ' ha') : '—');

    // ----- Title record (kept as text so existing
    //       .property-title.text() lookups in watchPropertyNotes work) -----
    setText(detail, 'prp-title', data.title_no || '—');

    // ----- Registered owners -----
    const ownersWrap = detail.querySelector('[data-bind="prp-owners"]');
    const ownerTpl = document.getElementById('prp-owner-row-template');
    if (data.owners && ownersWrap && ownerTpl) {
        const companyRegex = /\b(limited|ltd)\b/i;
        data.owners.split(',').forEach(rawName => {
            const name = rawName.trim();
            if (!name) return;
            const row = ownerTpl.content.firstElementChild.cloneNode(true);
            const initEl = row.querySelector('[data-bind="owner-initials"]');
            if (initEl) initEl.textContent = ownerInitials(name);
            const nameEl = row.querySelector('[data-bind="owner-name"]');
            if (nameEl) nameEl.textContent = name;
            const lookup = row.querySelector('[data-bind="owner-lookup"]');
            if (lookup && companyRegex.test(name)) {
                lookup.href = 'https://coys.carjam.co.nz/:entities?q='
                    + name.replace(/\s+/g, '+');
                lookup.hidden = false;
            }
            const filterBtn = row.querySelector('[data-bind="owner-filter"]');
            if (filterBtn) filterBtn.dataset.owner = name;
            ownersWrap.appendChild(row);
        });
    }

    // ----- Legal description -----
    setText(detail, 'prp-legal', data.estate_description || '—');

    // ----- Additional information (custom data from company features) -----
    const extraSection = detail.querySelector('[data-section="extra"]');
    const extraWrap = detail.querySelector('[data-bind="prp-extra"]');
    let extraVisible = false;
    if (data.information && extraWrap) {
        try {
            const info = typeof data.information === 'string'
                ? JSON.parse(data.information)
                : data.information;
            const rowTpl = document.getElementById('prp-extra-row-template');
            if (rowTpl) {
                Object.keys(info).forEach(key => {
                    const frag = rowTpl.content.cloneNode(true);
                    const keyEl = frag.querySelector('[data-bind="extra-key"]');
                    const valEl = frag.querySelector('[data-bind="extra-value"]');
                    if (keyEl) keyEl.textContent = key;
                    if (valEl) valEl.textContent = info[key];
                    extraWrap.appendChild(frag);
                });
                extraVisible = true;
            }
        } catch (e) { /* malformed JSON: silently skip */ }
    }
    if (data.url) {
        const linkWrap = detail.querySelector('[data-bind="prp-link-wrap"]');
        const link = detail.querySelector('[data-bind="prp-link"]');
        if (link) {
            link.href = data.url;
            link.textContent = data.url;
        }
        if (linkWrap) linkWrap.hidden = false;
        extraVisible = true;
    }
    if (extraSection) extraSection.hidden = !extraVisible;

    // ----- Highlight colour swatches + hidden <select> mirror -----
    /*const swatchWrap = detail.querySelector('[data-bind="prp-swatches"]');
    const swatchTpl = document.getElementById('prp-swatch-template');
    const select = detail.querySelector('select[name="fill_colour"]');
    if (swatchWrap && swatchTpl) {
        const current = data.fill_colour || '';

        // Default swatch (clears highlight)
        const defaultSw = swatchTpl.content.firstElementChild.cloneNode(true);
        defaultSw.dataset.colour = '';
        defaultSw.title = 'Default';
        const defaultDot = defaultSw.querySelector('.rm-rp-swatch__dot');
        if (defaultDot) {
            defaultDot.style.background = '#fff';
            defaultDot.style.border = '1px dashed #b0b0b0';
        }
        if (!current) defaultSw.classList.add('is-active');
        swatchWrap.appendChild(defaultSw);

        Object.keys(featureColors).forEach(name => {
            const hex = featureColors[name];
            const sw = swatchTpl.content.firstElementChild.cloneNode(true);
            sw.dataset.colour = hex;
            sw.title = name;
            const dot = sw.querySelector('.rm-rp-swatch__dot');
            if (dot) dot.style.background = hex;
            if (hex === current) sw.classList.add('is-active');
            swatchWrap.appendChild(sw);

            if (select) {
                const opt = document.createElement('option');
                opt.value = hex;
                opt.textContent = name;
                if (hex === current) opt.selected = true;
                select.appendChild(opt);
            }
        });
    }*/
    renderColourSelector(detail, data);

    // Swap the new detail into the panel
    content.innerHTML = '';
    content.appendChild(detail);

    // Reveal: the `.is-open` class drives the slide-in CSS transition.
    // (Adding it again when already open — e.g. prev/next cycling — is a
    // no-op, so the content just swaps instantly without re-animating.)
    panel.classList.add('is-open');
    const wrapper = document.querySelector('.rural-map');
    if (wrapper) wrapper.classList.add('right-panel-open');
}

/**
 * Builds BOTH the compact swatch grid and the editable legend rows for the
 * currently open property, then shows whichever one is appropriate:
 *  - legend view, if the user has clicked the edit pencil, OR if any
 *    colour has already been renamed away from its default
 *  - swatch view otherwise
 */
function renderColourSelector(detail, data) {
    const current = data.fill_colour || '';

    const swatchWrap = detail.querySelector('[data-bind="prp-swatches"]');
    const legendWrap = detail.querySelector('[data-bind="prp-legend"]');
    const editBtn = detail.querySelector('[data-bind="prp-legend-edit"]');
    const swatchTpl = document.getElementById('prp-swatch-template');
    const legendRowTpl = document.getElementById('prp-legend-row-template');
    const select = detail.querySelector('select[name="fill_colour"]');

    if (!swatchWrap || !legendWrap || !swatchTpl || !legendRowTpl || !select) return;

    // ----- Default / "clear highlight" entries (both views) -----
    const defaultSw = swatchTpl.content.firstElementChild.cloneNode(true);
    defaultSw.dataset.colour = '';
    defaultSw.title = 'Default';
    const defaultDot = defaultSw.querySelector('.rm-rp-swatch__dot');
    if (defaultDot) {
        defaultDot.style.background = '#fff';
        defaultDot.style.border = '1px dashed #b0b0b0';
    }
    if (!current) defaultSw.classList.add('is-active');
    swatchWrap.appendChild(defaultSw);

    // Default row — kept visually distinct (white pill) since there's no
    // hex to fill it with.
    const defaultRow = document.createElement('div');
    defaultRow.className = 'rm-rp-legend-row rm-rp-legend-row--default';
    defaultRow.dataset.colour = '';
    defaultRow.innerHTML =
        '<span class="rm-rp-legend-row__indicator" data-bind="legend-indicator" aria-hidden="true">' +
        '<i class="fa-solid fa-check"></i></span>' +
        '<span class="rm-rp-legend-row__label">Default (no highlight)</span>';
    if (!current) defaultRow.classList.add('is-active');
    legendWrap.appendChild(defaultRow);

    // One pill row per colour
    Object.keys(featureColors).forEach(hex => {
        const name = featureColors[hex]; // '' if unnamed

        const row = legendRowTpl.content.firstElementChild.cloneNode(true);
        row.dataset.colour = hex;
        row.style.background = hex;
        if (hex === current) row.classList.add('is-active');

        const nameInput = row.querySelector('[data-bind="legend-name-input"]');
        if (nameInput) {
            nameInput.value = name;
            nameInput.dataset.hex = hex;
            nameInput.dataset.originalName = name;
        }
        legendWrap.appendChild(row);

        // Swatch grid + hidden <select> mirror unchanged — still needed
        const sw = swatchTpl.content.firstElementChild.cloneNode(true);
        sw.dataset.colour = hex;
        sw.title = name || hex;
        const dot = sw.querySelector('.rm-rp-swatch__dot');
        if (dot) dot.style.background = hex;
        if (hex === current) sw.classList.add('is-active');
        swatchWrap.appendChild(sw);

        const opt = document.createElement('option');
        opt.value = hex;
        opt.textContent = name || hex;
        if (hex === current) opt.selected = true;
        select.appendChild(opt);
    });

    // ----- Decide which view wins -----
    // const showLegend = legendEditMode || hasCustomColourNames();
    // swatchWrap.hidden = showLegend;
    // legendWrap.hidden = !showLegend;
    // if (editBtn) {
    //     editBtn.classList.toggle('is-active', showLegend);
    //     editBtn.querySelector('i').className = showLegend ? 'fa-solid fa-check' : 'fa-solid fa-pen';
    // }
    const showLegend = hasCustomColourNames() || legendEditMode;
    swatchWrap.hidden = showLegend;
    legendWrap.hidden = !showLegend;
    // const saveBtn = detail.querySelector('[data-bind="prp-legend-save"]');
    if (editBtn) editBtn.hidden = showLegend;
    // if (saveBtn) saveBtn.hidden = !showLegend;
}

/** Re-runs renderColourSelector against the panel that's already on screen,
 *  e.g. after a rename or after the pencil icon is clicked. Keeps the
 *  currently-selected colour intact by reading it off the hidden select
 *  before wiping everything. */
function refreshColourSelector(detail) {
    const select = detail.querySelector('select[name="fill_colour"]');
    const current = select ? select.value : '';

    const swatchWrap = detail.querySelector('[data-bind="prp-swatches"]');
    const legendWrap = detail.querySelector('[data-bind="prp-legend"]');
    if (swatchWrap) swatchWrap.innerHTML = '';
    if (legendWrap) legendWrap.innerHTML = '';
    if (select) select.innerHTML = '<option value="">Default Colour</option>';

    renderColourSelector(detail, { fill_colour: current });
}

/** Renames a colour in-memory. Test-data only for now — swap the
 *  customColors mutation below for a real save call (e.g. POST to a new
 *  /MapData/saveColourName endpoint) once the backend exists. */
function renameFeatureColour(hex, newName) {
    if (!newName) {
        delete customColors[hex]; // blank = unnamed, not stored
    } else {
        customColors[hex] = newName;
    }

    rebuildFeatureColours();
    return true;
}

function showFeatureLandUse(feature) {
    // ----- Land Use (from LUCAS) — lazy: compute this single title's
    // overlaps now and cache positives for later filter passes. -----
    const detail = document.getElementById('right-panel-content');
    const landUseSection = detail.querySelector('[data-section="land-use"]');
    const landUseWrap = detail.querySelector('[data-bind="prp-land-use"]');
    const landUseTypes = getTitleLandUseTypes(feature);
    if (landUseTypes.length && landUseWrap) {
        landUseTypes.forEach(slug => {
            const tag = document.createElement('span');
            tag.className = 'rm-rp-tag';
            tag.textContent = LUCAS_TYPE_LABELS[slug] || slug;
            landUseWrap.appendChild(tag);
        });
        if (landUseSection) landUseSection.classList.remove('loading');
    }
}

function setText(root, bindName, value) {
    const el = root.querySelector('[data-bind="' + bindName + '"]');
    if (el) el.textContent = value;
}

function clearRightPanel() {
    const panel = document.getElementById('right-panel');
    const content = document.getElementById('right-panel-content');
    if (!panel || !content) return;

    // Removing `.is-open` triggers the slide-out CSS transition. The panel
    // stays in the DOM (just translated off-screen) so it can slide back in
    // later. The contents are wiped only AFTER the 0.3s slide finishes, so
    // the user doesn't see the panel empty itself mid-animation.
    panel.classList.remove('is-open');

    map.resize();

    const wrapper = document.querySelector('.rural-map');
    if (wrapper) wrapper.classList.remove('right-panel-open');

    window.setTimeout(function () {
        // Guard: if a new property was opened during the slide-out, the
        // panel will be `.is-open` again — don't wipe the fresh contents.
        if (panel.classList.contains('is-open')) return;
        content.innerHTML = '';
        const addressEl = panel.querySelector('[data-bind="prp-address"]');
        if (addressEl) addressEl.textContent = '';
        const locText = panel.querySelector('[data-bind="prp-location-text"]');
        if (locText) locText.textContent = '';
        const nav = panel.querySelector('[data-bind="prp-nav"]');
        if (nav) nav.style.display = 'none';
    }, 320);
}

function getLandAreaFromTitle(feature) {
    let data = feature.properties ?? {};
    if (data.estate_description) {
        const match = data.estate_description.match(/(\d[\d,]*)\s*m2/g);
        if (match) {
            let m2 = 0;
            for (let i = 0; i < match.length; i++) {
                m2 += parseFloat(match[i].replace(/,/g, ''));
            }
            if (m2 > 0) {
                return (m2 / 10000).toFixed(1).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            }
        }
    }

    return '-';
}

/* =====================================================================
 * Left panel: collapse toggle, swatch clicks, route mode buttons
 * ===================================================================== */

$(document).ready(function () {
    // Left panel collapse toggle (chevron on the outer edge).
    // The map is never resized — the panel just slides over it (Google Maps
    // style) — so there's no map.resize() here. fitBounds padding (see
    // showRoute) keeps routed geometry clear of whichever panels are open.
    $('#left-panel-toggle').on('click', function () {
        const $wrapper = $('#left-panel-wrapper');
        $wrapper.toggleClass('is-collapsed');
        $(this).find('i')
            .toggleClass('fa-chevron-left')
            .toggleClass('fa-chevron-right');
    });

    // Highlight colour swatches inside the right panel.
    // We mirror the click into the hidden <select name="fill_colour">
    // and trigger its change event so the existing watchPropertyNotes
    // handler (which writes to userHighlights and repaints the map)
    // keeps working without modification.
    $(document).on('click', '#right-panel .rm-rp-swatch', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const $btn = $(this);
        const colour = $btn.attr('data-colour') || '';
        const $form = $btn.closest('.property-notes-form');
        $form.find('.rm-rp-swatch').removeClass('is-active');
        $btn.addClass('is-active');
        $form.find('select[name="fill_colour"]').val(colour).trigger('change');
    });

    // Pencil icon: manually toggle legend/edit view for the colour selector
    $(document).on('click', '#right-panel [data-bind="prp-legend-edit"]', function (e) {
        e.preventDefault();
        legendEditMode = true; // one-way — never set back to false by this button
        refreshLegendVisibility();
    });

// Colour swatch inside the legend row (mirrors the existing .rm-rp-swatch handler)
    $(document).on('click', '#right-panel .rm-rp-legend-row', function (e) {
        if (e.target.closest('input')) return; // let typing/focus through untouched
        e.preventDefault();

        const $row = $(this);
        const colour = $row.data('colour') || '';
        const $form = $row.closest('.property-notes-form');

        $form.find('.rm-rp-legend-row, .rm-rp-swatch').removeClass('is-active');
        $row.addClass('is-active');
        $form.find('select[name="fill_colour"]').val(colour).trigger('change');
    });

    // Save button: batch up every renamed colour and persist it
    /*$(document).on('click', '#right-panel [data-bind="prp-legend-save"]', function (e) {
        e.preventDefault();
        const $btn = $(this);

        $btn.prop('disabled', true).addClass('saving');

        saveCustomColours(customColors)
            .then(function () {
                legendEditMode = false;
                const detail = document.querySelector('#right-panel-content .prp-deets-container');
                if (detail) refreshColourSelector(detail);
            })
            .catch(function () {
                alert('Could not save your colour legend. Please try again.');
            })
            .always(function () {
                $btn.prop('disabled', false).removeClass('saving');
            });
    });*/

    /**
     * Persists the user's custom colour names.
     * /MapData/saveCustomColours that accepts { colours: [{hex,name}, ...] }
     * for the logged-in member, and returns { success: true } on save.
     */
    function saveCustomColours(colours) {
        const safeColours = {};
        Object.keys(colours || {}).forEach(key => {
            if (typeof colours[key] === 'string') safeColours[key] = colours[key];
        });

        return $.ajax({
            url: '/MapData/saveCustomColours',
            method: 'POST',
            data: { colours: JSON.stringify(safeColours) },
            dataType: 'json'
        });
    }

    function persistColourRename($status) {
        $status.text('Saving…').prop('hidden', false);

        saveCustomColours(customColors)
            .then(function () {
                $status.text('Saved');
                setTimeout(function () {
                    $status.fadeOut(200, function () {
                        $(this).prop('hidden', true).show();
                    });
                }, 1200);
            })
            .catch(function () {
                $status.text('Could not save — check your connection');
            });
    }

// Renaming a colour from the legend textbox
    $(document).on('focusout', '#right-panel [data-bind="legend-name-input"]', function () {
        const $input = $(this);
        const hex = $input.data('hex');
        const originalName = $input.data('originalName');
        const newName = $input.val().trim();

        if (newName === originalName) return; // nothing changed, nothing to save

        renameFeatureColour(hex, newName);

        $input.val(newName);
        $input.data('originalName', newName);

        refreshLegendVisibility(); // see below — may need to switch swatch→legend now
        // persistColourRename($('#right-panel [data-bind="prp-legend-status"]'));
        saveCustomColours(customColors);
    });

    function refreshLegendVisibility() {
        const detail = document.querySelector('#right-panel-content .prp-deets-container');
        if (detail) refreshColourSelector(detail);
    }

    $(document).on('keydown', '#right-panel [data-bind="legend-name-input"]', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            $(this).trigger('focusout');
        }
    });

    // Route mode buttons: clicking Car / Heavy / Walk sets the hidden
    // #routeType value and triggers change so the existing route-regen
    // listener (defined in initMap) picks it up.
    $(document).on('click', '.rm-route__mode', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const $btn = $(this);
        $btn.siblings('.rm-route__mode').removeClass('active');
        $btn.addClass('active');
        const value = $btn.attr('data-route-type');
        $('#routeType').val(value).trigger('change');
    });

    // Stop bubbling on routing input clicks so they don't toggle the
    // parent .option.route-tool card off.
    $(document).on('click',
        '#routeTool input, #routeTool select, #routeTool button, #routeStart, #routeEnd',
        function (e) {
            e.stopPropagation();
        }
    );

    // Property Type filter (LeftPanel checkboxes). Re-runs the title
    // filter so the map updates as the user ticks/unticks types. All
    // titles still render when nothing is ticked — see filteredTitles().
    //
    // The filtering work in applyOwnerFilter() is synchronous and can be
    // heavy (turf intersections). If we called it straight away the
    // browser would never paint the `loading` class before the work ran,
    // and filteredTitles() removes the class again at its end — so the
    // spinner would never be visible. Instead we add the class, then wait
    // for two animation frames: the first lets the browser paint the
    // `loading` state, the second runs the actual filtering.
    $(document).on('change',
        '[data-field="property-type"] input[type="checkbox"][data-property-type]',
        function () {
            $(this).closest('.rm-checkbox-list').addClass('loading');
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    applyOwnerFilter();
                });
            });
        }
    );

    $( function() {
        $("#property-size").slider({
            range: true,
            min: 0,
            max: 1000,
            values: [ 0, 1000 ],
            slide: function( event, ui ) {
                let postfix = '';
                if(ui.values[ 1 ] == 1000) {
                    postfix = '+';
                }
                $( ".rm-field__value" ).html( ui.values[ 0 ] + "ha - " + ui.values[ 1 ] + 'ha' + postfix );
            },
            stop: function( event, ui ) {
                let filteredTitles = propertyTitles.filter(feature => {
                    return isFeatureShown(feature);
                });
                loadTitlesToMap(filteredTitles)
            }
        });
        $( ".rm-field__value" ).html( $( "#property-size" ).slider( "values", 0 ) +
            "ha - " + $( "#property-size" ).slider( "values", 1 ) + 'ha+' );
    } );

    let resizeInterval = null;

    $('#left-panel-wrapper').on('transitionstart', () => {
        clearInterval(resizeInterval);
        resizeInterval = setInterval(() => {
            map.resize();
        }, 20);
        mapResizing = true
    });

    $('#left-panel-wrapper').on('transitionend', () => {
        clearInterval(resizeInterval);
        resizeInterval = null;
        map.resize(); // final redraw to ensure clean end state
        mapResizing = false
    });
});
